import Swiper, { Pagination, EffectFade } from "swiper";

(() => {
  const swipersNodeList = document.querySelectorAll(".kw-bs--swiper");
  swipersNodeList.forEach((node) => {
    let _t = $(node);
    const effect = $(".is-mobile").is(":visible") ? "slide" : "fade";
    let swiper = new Swiper(node, {
      modules: [Pagination, EffectFade],
      effect,
      fadeEffect: {
        crossFade: true,
      },
      autoHeight: true,
      pagination: {
        el: _t.find(".kw-bs--pagination")[0],
        clickable: true,
        renderBullet: function (index, className) {
          const dataKey = $(".is-mobile").is(":visible") ? "title-sm" : "title";
          return (
            `<span class="${className} kw-bs--pagination-bullet">` +
            _t.find(`.kw-bs--body[data-index="${index}"]`).data(dataKey) +
            "</span>"
          );
        },
      },
    });
  });
})();
